export const Characters = [
  ['一', '二', '三', '四', '五'],
  ['六', '七', '八', '九', '十'],
  ['人', '口'],
  ['眼', '睛'],
  ['耳', '朵'],
  ['嘴', '巴'],
  ['大', '小'],
  ['多', '少'],
  ['足', '球'],
  ['你', '好'],
  ['再', '见'],
  ['日', '月'],
  ['月', '亮'],
  ['山', '坡'],
  ['石', '头'],
  ['谢', '谢'],
  ['不', '客', '气'],
  ['老', '师', '好'],
  ['我', '是', '王', '小', '华'],
  ['他', '是', '我', '爸', '爸'],
  ['她', '是', '我', '妈', '妈'],
  ['我', '爱', '妈', '妈'],
  ['我', '爱', '爸', '爸', '妈', '妈'],
  ['爸', '爸', '是', '老', '师'],
  ['叔', '叔', '是', '警', '察'],
  ['妈', '妈', '是', '医', '生'],
  ['哥', '哥', '是', '学', '生'],
  ['请', '帮', '爸', '爸', '妈', '妈'],
  ['你', '叫', '什', '么', '名', '字'],
]

export function getRandomPhrase() {
  let randomPhrase = Characters[Math.floor(Math.random() * Characters.length)]
  return randomPhrase
}
